import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing.large,
    alignItems: "stretch",
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.large})`,
}));

export const Header = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: theme.spacing.medium,
}));

export const PaymentAmountText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
}));
